import React from 'react';

const LineChartPlaceholder = () => {
    return (
        <div>
            <svg width="96" height="67" viewBox="0 0 96 67" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_b)">
                    <rect x="15.2227" y="0.5" width="66.4391" height="66.3462" rx="10" fill="#E4E7F5" />
                </g>
                <path
                    opacity="0.8"
                    d="M45.547 48.0957H35.1155C34.3505 48.0957 33.7246 47.4707 33.7246 46.7068C33.7246 45.9429 34.3505 45.3179 35.1155 45.3179H45.547C46.312 45.3179 46.9379 45.9429 46.9379 46.7068C46.9379 47.4707 46.312 48.0957 45.547 48.0957Z"
                    fill="#8D98B7"
                />
                <path
                    opacity="0.3"
                    d="M53.1968 55.0396H35.1155C34.3505 55.0396 33.7246 54.4146 33.7246 53.6506C33.7246 52.8867 34.3505 52.2617 35.1155 52.2617H53.1968C53.9618 52.2617 54.5877 52.8867 54.5877 53.6506C54.5877 54.4146 53.9618 55.0396 53.1968 55.0396Z"
                    fill="#8D98B7"
                />
                <path
                    d="M2 36.4835C13.3982 36.4835 15.8407 14.8667 24.7965 14.8667C33.7522 14.8667 34.5664 30.8791 40.2655 30.8791C45.9646 30.8791 47.5929 24.4742 53.292 24.4742C58.9912 24.4742 62.2478 35.6829 69.5752 35.6829C77.7168 35.6829 82.6018 14.8667 94 14.8667"
                    stroke="#8D98B7"
                    strokeWidth="2.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <defs>
                    <filter
                        id="filter0_b"
                        x="-0.777344"
                        y="-15.5"
                        width="98.4391"
                        height="98.3462"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feGaussianBlur in="BackgroundImage" stdDeviation="8" />
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur" result="shape" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};

export default LineChartPlaceholder;
